export const getVisibleHeight = element => {
	let visiblePx = 0;

	const rect = element.getBoundingClientRect(),
		height = rect.bottom - rect.top,
		visible = {
			top: rect.top >= 0 && rect.top < window.innerHeight,
			bottom: rect.bottom > 0 && rect.bottom < window.innerHeight,
		};

	if (visible.top && visible.bottom) {
		visiblePx = height;
	} else if (visible.top) {
		visiblePx = window.innerHeight - rect.top;
	} else if (visible.bottom) {
		visiblePx = rect.bottom;
	} else if (height > window.innerHeight && rect.top < 0) {
		const absTop = Math.abs(rect.top);

		if (absTop < height) {
			visiblePx = height - absTop;
		}
	}

	return visiblePx;
};

export const getMostVisible = elements => {
	let mostVisibleElement,
		max = 0;

	for (const element of elements) {
		const visiblePx = getVisibleHeight(element);

		if (visiblePx > max) {
			max = visiblePx;
			mostVisibleElement = element;
		}
	}

	return mostVisibleElement;
};
